export default "__VITE_ASSET__QjInKi$F__"